import { gql } from '@apollo/client'

export default gql`
  mutation DeleteServiceType($uuid: ID!) {
    deleteServiceType(uuid: $uuid)
  }
`
